module.exports = __webpack_public_path__ + "img/center.685334ad.svg";